import { createAction, props } from '@ngrx/store';

export const loadProfileLists = createAction('[List] Load Profile Lists');

export const loadProfileListsSuccess = createAction(
  '[List] Load Profile Lists Success',
  props<{ profileLists: any[] }>()
);

export const loadProfileListsFailure = createAction(
  '[List] Load Profile Lists Failure',
  props<{ error: any }>()
);
